import { ref } from 'vue'

// Estado global para o clipboard
const infoTecnicasCopiado = ref<any>(null)
const copiado = ref(false)

export function useVehicleClipboard() {
  const copiarDadosTecnicos = (dadosVeiculo) => {
    copiado.value = true
    infoTecnicasCopiado.value = {
      lubrificante_sae: dadosVeiculo.lubrificante_sae,
      lubrificante_acea: dadosVeiculo.lubrificante_acea,
      lubrificante_api: dadosVeiculo.lubrificante_api,
      lubrificante_base: dadosVeiculo.lubrificante_base,
      lubrificante_ilsac: dadosVeiculo.lubrificante_ilsac,
      lubrificante_oem: dadosVeiculo.lubrificante_oem,
      carter_com_filtro: dadosVeiculo.carter_com_filtro,
      pneu_dianteiro_1: dadosVeiculo.pneu_dianteiro_1,
      pneu_dianteiro_2: dadosVeiculo.pneu_dianteiro_2,
      pneu_traseiro_1: dadosVeiculo.pneu_traseiro_1,
      pneu_traseiro_2: dadosVeiculo.pneu_traseiro_2,
      modelo_palheta: dadosVeiculo.modelo_palheta,
      motorista_palheta: dadosVeiculo.motorista_palheta,
      passageiro_palheta: dadosVeiculo.passageiro_palheta,
      traseiro_palheta: dadosVeiculo.traseiro_palheta,
      adaptador_palheta: dadosVeiculo.adaptador_palheta
    }
    console.log('DadosTecnicos copiados:', infoTecnicasCopiado.value)
  }

  const colarDadosTecnicos = (targetObject = null) => {
    if (!copiado.value || !infoTecnicasCopiado.value) {
      console.warn('Nenhum produto copiado para colar')
      return null
    }
    
    const dados = { ...infoTecnicasCopiado.value }
    
    // Se um targetObject foi passado, atualiza-o diretamente
    if (targetObject && typeof targetObject === 'object') {
      Object.assign(targetObject, dados)
      console.log('Objeto atualizado com dados colados:', targetObject)
    }
    
    return dados
  }

  const limparClipboard = () => {
    copiado.value = false
    infoTecnicasCopiado.value = null
  }

  return {
    copiado,
    infoTecnicasCopiado,
    copiarDadosTecnicos,
    colarDadosTecnicos,
    limparClipboard
  }
}

export function useCaminhaoClipboard() {
  const copiarDadosTecnicos = (dadosVeiculo) => {
    copiado.value = true
    infoTecnicasCopiado.value = {
      lubrificante_sae: dadosVeiculo.lubrificante_sae,
      carter_com_filtro: dadosVeiculo.lubrificante_acea,
      lubrificante_base: dadosVeiculo.lubrificante_api,
      lubrificante_api: dadosVeiculo.lubrificante_base,
      lubrificante_acea: dadosVeiculo.lubrificante_ilsac,
      lubrificante_oem: dadosVeiculo.lubrificante_oem,
      lubrificante_ilsac: dadosVeiculo.carter_com_filtro,
      pneu_dianteiro_1: dadosVeiculo.pneu_dianteiro_1,
      pneu_dianteiro_2: dadosVeiculo.pneu_dianteiro_2,
      pneu_traseiro_1: dadosVeiculo.pneu_traseiro_1,
      pneu_traseiro_2: dadosVeiculo.pneu_traseiro_2,
      lubrificante_diferencial_sae: dadosVeiculo.lubrificante_diferencial_sae,
      lubrificante_diferencial_base: dadosVeiculo.lubrificante_diferencial_base,
      lubrificante_diferencial_volume_dianteiro: dadosVeiculo.lubrificante_diferencial_volume_dianteiro,
      lubrificante_diferencial_volume_traseiro_1_eixo: dadosVeiculo.lubrificante_diferencial_volume_traseiro_1_eixo,
      lubrificante_diferencial_volume_traseiro_2_eixo: dadosVeiculo.lubrificante_diferencial_volume_traseiro_2_eixo,
      lubrificante_diferencial_api: dadosVeiculo.lubrificante_diferencial_api,
      lubrificante_diferencial_mil: dadosVeiculo.lubrificante_diferencial_mil,
      lubrificante_diferencial_oem: dadosVeiculo.lubrificante_diferencial_oem,
      lubrificante_diferencial_obs: dadosVeiculo.lubrificante_diferencial_obs,
    }
    console.log('DadosTecnicos copiados:', infoTecnicasCopiado.value)
  }

  const colarDadosTecnicos = (targetObject = null) => {
    if (!copiado.value || !infoTecnicasCopiado.value) {
      console.warn('Nenhum produto copiado para colar')
      return null
    }
    
    const dados = { ...infoTecnicasCopiado.value }
    
    // Se um targetObject foi passado, atualiza-o diretamente
    if (targetObject && typeof targetObject === 'object') {
      Object.assign(targetObject, dados)
      console.log('Objeto atualizado com dados colados:', targetObject)
    }
    
    return dados
  }

  const limparClipboard = () => {
    copiado.value = false
    infoTecnicasCopiado.value = null
  }

  return {
    copiado,
    infoTecnicasCopiado,
    copiarDadosTecnicos,
    colarDadosTecnicos,
    limparClipboard
  }
}